var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1.5238C13 1.65515 12.9791 1.78522 12.9383 1.90658C12.8975 2.02795 12.8376 2.13823 12.7622 2.23114L7.84062 8.2838C7.48473 8.72062 7.00262 8.96593 6.5 8.96593C5.99738 8.96593 5.51527 8.72062 5.15937 8.2838L0.237791 2.2298C0.0925083 2.0405 0.0129557 1.78891 0.0160465 1.52853C0.0191374 1.26816 0.104629 1.01954 0.254342 0.835533C0.404056 0.65153 0.606181 0.546662 0.817739 0.543226C1.0293 0.539791 1.2336 0.63806 1.38721 0.817136L6.30825 6.87447C6.35904 6.93696 6.42791 6.97206 6.49973 6.97206C6.57154 6.97206 6.64042 6.93696 6.69121 6.87447L11.6128 0.817136C11.7264 0.677232 11.8711 0.581931 12.0288 0.543287C12.1864 0.504643 12.3497 0.524391 12.4982 0.600034C12.6467 0.675676 12.7736 0.803816 12.863 0.968246C12.9523 1.13268 13 1.32601 13 1.5238Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.cc7ee7c7d33b424061c8bda8e118255b.svg";
export { ForwardRef as ReactComponent };